


import { isMeetingSessionRoleGreaterThanOrEqual, MeetingContainerAPI } from "@kalyzee/kast-web-sdk";
import { MeetingSessionRole } from "@kalyzee/kast-web-sdk/websocket";
import { useMeetingSelector } from "../../../hooks/meeting";
import { SurveyCreatorWorkBox } from "./SurveyCreatorWorkBox";
import { SurveyViewerWorkBox } from "./SurveyViewerWorkBox";

export interface SurveyWorkBoxProps {
  meetingAPI: MeetingContainerAPI;
}

export const SurveyWorkBox = ({
  meetingAPI,
}: SurveyWorkBoxProps) => {
  const [survey] = useMeetingSelector(meetingAPI, state => state.surveys?.[0]);
  const [role] = useMeetingSelector(meetingAPI, state => state.session?.role);
  // Ici, si sondage => affichage (en mode admin ou élève) sinon création
  // l'affichage, en mode élève, on choisi une réponse et ensuite on attend,
  // quand le prof a validé, on voit les résultats, avec prof, on affiche toujours
  // la workbox d'affichage va très bien se partager
  
  if (!meetingAPI || !role) return null;

  const isAdmin = isMeetingSessionRoleGreaterThanOrEqual(role, MeetingSessionRole.MODERATOR);

  if (!survey && isAdmin) {
    return (
      <SurveyCreatorWorkBox
        meetingAPI={meetingAPI} 
      />
    );
  }

  return (
    <SurveyViewerWorkBox
      meetingAPI={meetingAPI}  
      survey={survey} 
      isAdmin={isAdmin}
    />
  );
};
